import React, { Component } from 'react'
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";

export default class Footter extends Component {
    render() {
        return (
            <div>
        <footer className="footer--pin">
        <MDBFooter color="cyan darken-4" className="font-small pt-4 mt-0" >
          <MDBContainer fluid className="text-center text-md-left">
            <MDBRow>
              <MDBCol md="12">
                <h5 className="title"> Kamphaeng Phet Rajabhat University</h5>
                <p>
                  ระบบบริหารจัดการตารางเรียน-ตารางสอน โดย สำนักส่งเสริมวิชาการและงานทะเบียน
                </p>
              </MDBCol>
            
            </MDBRow>
          </MDBContainer>
          <div className="footer-copyright text-center py-3">
            <MDBContainer fluid>
              &copy; {new Date().getFullYear()} Copyright: <a href="https://www.kpru.ac.th/"> www.kpru.ac.th </a>
            </MDBContainer>
          </div>
        </MDBFooter>
        </footer>
            </div>
        )
    }
}
